import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, Output, SimpleChanges, ViewChild, EventEmitter } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { FarmService } from 'src/app/services/farm-service.service';

@Component({
  selector: 'smart-manage-thing-sensor-create',
  templateUrl: './manage-thing-sensor-create.component.html',
  styleUrls: ['./manage-thing-sensor-create.component.scss','../../platform-color/platform-color.css']
})
export class ManageThingSensorCreateComponent implements OnInit {
  submitted: boolean = false;
  form: FormGroup;
  @Input()
  createThing: any;
  @Input()
  filter: any;
  sensorList: any = [];
  sensorType: any = [];
  AllSensorType: any = [];

  sensorTab: number = 0;
  mapNumber: number = 0;

  editMap = null;

  @Output() done = new EventEmitter<any>();
  @ViewChild("closeModal") private closeModal: ElementRef;
  constructor( 
    private formBuilder: FormBuilder,
    private FarmService: FarmService,
    private spinner: NgxSpinnerService,

    private cd: ChangeDetectorRef
    ) { }
  

  ngOnInit(): void {
    if(this.createThing){
      this.spinner.show();

      this.FarmService.getAllSensorByThingsID(this.createThing.ThingId, this.filter.plot_id).subscribe(res=>{
        let sensors = res.data || [];
        
        for(let i = 0; i< this.createThing.SensorInfo.length; i++){

          if(!sensors.find(sensor=> sensor.sensor_id == this.createThing.SensorInfo[i].SensorKey)){
            this.sensorList.push(this.createSensorItem(this.createThing.SensorInfo[i], i));
          }
        }
        this.FarmService.getSensorType().subscribe(res=>{
          if(res.code == 200){
            this.AllSensorType = res.data;
            this.onChangeSensorType("RCPT");
          }
        });
        this.spinner.hide();
      });
    }
  }

  onChangeSensorType(value, page?: number){
    if(value){
      if(page >=0){
        if(value == 'RCPT'){
    
          this.sensorList.controls[page].get('auto_sync_flag').setValue(false);
        }
      }
      this.spinner.show();
      this.sensorType = this.AllSensorType.filter(sensor=> sensor.type == value);
      this.spinner.hide();
    }
  }

  onChangeType(value, page: number){

    if(value){
      let sensor = this.sensorType.find(sensor=> sensor.code == value);
      this.sensorList.controls[page].get('sensor_unit').setValue(sensor.unit);
      if(sensor.icon){
        if(sensor.icon.length > 0){
          this.sensorList.controls[page].get('img').setValue(sensor.icon[0].normal);
          let sensor_img = sensor.icon[0].normal.split(".")[0];

          if(sensor_img.includes("/")){
            sensor_img = sensor_img.split("/")[1];
          }
          
          this.sensorList.controls[page].get('sensor_img').setValue(sensor_img);
        }
      }else{
        this.form.get('img').setValue("");
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {

    if (
      changes.createThing
    ) {
      this.createForm();
      this.ngOnInit();
    }
  }

  createForm(){
    this.form = this.formBuilder.group({
      sensors: this.formBuilder.array([])
    });
    this.sensorList = this.form.get('sensors') as FormArray;
  }

  getSensorFormGroup(index): FormGroup {
    const formGroup = this.form.controls[index] as FormGroup;
    return formGroup;
  }
  get sensorFormGroup() {
    return this.form.get('sensors') as FormArray;
  }
  createSensorItem(data:any = {}, i): FormGroup {
    return this.formBuilder.group({
      type: this.formBuilder.control("Sensing"),
      sensor_type: this.formBuilder.control("RCPT"),
      sensor_unit: this.formBuilder.control("*"),
      sensor_id: this.formBuilder.control(data.SensorKey || ""),
      sensor_name: this.formBuilder.control(data.SensorKey || ""),
      sensor_desc: this.formBuilder.control(""),
      sensor_img: this.formBuilder.control("Sensing"),
      sensor_min: this.formBuilder.control(0),
      sensor_max: this.formBuilder.control(100),
      sensor_bottom_border: this.formBuilder.control(0),
      sensor_top_border: this.formBuilder.control(100),
      lat: this.formBuilder.control(this.filter.farm_info.coordinates.center.lat),
      lon: this.formBuilder.control(this.filter.farm_info.coordinates.center.lon),
      img: this.formBuilder.control("/Sensing.png"),
      auto_sync_flag: this.formBuilder.control(data.auto_sync_flag || false),
    });
  }

  previous(){
    this.submitted = true;
    let sensor = (<FormArray>this.form.get('sensors')).value[this.sensorTab];
    if(    
      sensor.sensor_min > sensor.sensor_max ||
      sensor.sensor_bottom_border > sensor.sensor_top_border){
        return;
    }
    this.submitted = false;
    if(this.sensorTab != 0){
      this.sensorTab = this.sensorTab -1;
      if(this.sensorList.value[this.sensorTab].sensor_type){
        this.onChangeSensorType(this.sensorList.value[this.sensorTab].sensor_type, this.sensorTab);
      }else{
        this.sensorType = [];
      }
    }
  }

  next(){

    this.submitted = true;
    let sensor = (<FormArray>this.form.get('sensors')).value[this.sensorTab];
    if(    
      sensor.sensor_min > sensor.sensor_max ||
      sensor.sensor_bottom_border > sensor.sensor_top_border){
        return;
    }
    this.submitted = false;
    if(this.sensorTab != this.sensorList.length-1){
      this.sensorTab = this.sensorTab +1;

      if(this.sensorList.value[this.sensorTab].sensor_type){
        this.onChangeSensorType(this.sensorList.value[this.sensorTab].sensor_type,this.sensorTab);
      }else{
        this.sensorType = [];
      }
    }
  }

  fisrt(){
    this.submitted = true;
    let sensor = (<FormArray>this.form.get('sensors')).value[this.sensorTab];
    if(    
      sensor.sensor_min > sensor.sensor_max ||
      sensor.sensor_bottom_border > sensor.sensor_top_border){
        return;
    }
    this.submitted = false;
    this.sensorTab = 0;
    if(this.sensorList.value[this.sensorTab].sensor_type){
      this.onChangeSensorType(this.sensorList.value[this.sensorTab].sensor_type, this.sensorTab);
    }else{
      this.sensorType = [];
    }
  }

  last(){
    this.submitted = true;
    let sensor = (<FormArray>this.form.get('sensors')).value[this.sensorTab];
    if(    
      sensor.sensor_min > sensor.sensor_max ||
      sensor.sensor_bottom_border > sensor.sensor_top_border){
        return;
    }
    this.submitted = false;
    this.sensorTab = this.sensorList.length-1;
    if(this.sensorList.value[this.sensorTab].sensor_type){
      this.onChangeSensorType(this.sensorList.value[this.sensorTab].sensor_type, this.sensorTab);
    }else{
      this.sensorType = [];
    }
  }

  save(){
    this.submitted = true;
    let sensor = (<FormArray>this.form.get('sensors')).value[this.sensorTab];
    if(    
      sensor.sensor_min > sensor.sensor_max ||
      sensor.sensor_bottom_border > sensor.sensor_top_border){
        return;
    }
    this.submitted = false;
    
    let numberOfSuccess = 0;

    let sensors = this.setOrderBy(this.sensorList.value);


    for(let i = 0; i< sensors.length; i++){
      let sensor = this.sensorList.value[i];

      let data = {
          org_id: sessionStorage.getItem('Org'),
          child_org_id: sessionStorage.getItem('ChildOrg'),
          thing_id: this.createThing.ThingId,
          thing_key: this.createThing.ThingIdentifier,
          farm_id: [
            {
              farm_id: this.filter.farm_id
            }
          ],
          plot_id: [
            {
              plot_id: this.filter.plot_id
            }
          ],
          sensor_bottom_border: sensor.sensor_bottom_border.toString(),
          sensor_top_border: sensor.sensor_top_border.toString(),
          sensor_id: sensor.sensor_id,
          sensor_img: sensor.sensor_img? sensor.sensor_img: "null",
          sensor_max: sensor.sensor_max.toString(),
          sensor_min: sensor.sensor_min.toString(),
          sensor_name: sensor.sensor_name,
          sensor_type: sensor.sensor_type,
          sensor_unit: sensor.sensor_unit? sensor.sensor_unit: "null",
          sensor_desc: sensor.sensor_name,
          sensor_widget_staus: "Y",
          type: sensor.type,
          coordinates:{
            map_point:{
              lat: parseFloat(sensor.lat),
              lon: parseFloat(sensor.lon),
            }
          },
          auto_sync_flag:sensor.auto_sync_flag,
          order_by: sensor.order_by
      }

      this.FarmService.createSensor(data).subscribe(res=>{
        if(res.code == 200){
          numberOfSuccess = numberOfSuccess + 1;
        }

        setTimeout(() => {
          if(i == this.sensorList.value.length-1){
            if(numberOfSuccess == this.sensorList.value.length){
              this.done.emit(
                true
              );
              this.closeModal.nativeElement.click();
            }else{
              this.done.emit(
                numberOfSuccess
              );
              this.closeModal.nativeElement.click();
            }
          }
        }, 100);
      })
    }
  }

  setOrderBy(sensors){
    let imageSensors = sensors.filter(sensor => ['camera', 'video', 'image_capture'].includes(sensor.type));
    let otherSensors = sensors.filter(sensor => !['camera', 'video', 'image_capture'].includes(sensor.type));
    imageSensors.map((sensor)=>{
      sensor['order_by'] = 0;
    })
    otherSensors.map((sensor, index)=>{
      sensor['order_by'] = index+1;
    })
    
    return imageSensors.concat(otherSensors);
  }

  reset(){
    this.cd.detectChanges();
  }

  openMap(sensor, number: number){
    this.editMap = sensor;
    this.mapNumber = number;
  }

  pinMap(e){
    if(e){
      this.sensorList.controls.map((sensor, number)=>{
        if(number == this.mapNumber){
          sensor.get('lat').setValue(e.lat);
          sensor.get('lon').setValue(e.lng);
        }
      })
    }
    this.editMap = false;
  }
}
